// Getters
export const GET_PRODUCTS = "products/GET_PRODUCTS";
export const GET_PRODUCT = "products/GET_PRODUCT";
export const GET_PRODUCTPACKAGES = "products/GET_PRODUCTPACKAGES";
export const GET_PRODUCTPACKAGE = "products/GET_PRODUCTPACKAGE";

// Mutations
export const MUTATE_LOAD_PRODUCTS = "products/MUTATE_LOAD_PRODUCTS";
export const MUTATE_ADD_PRODUCT = "products/MUTATE_ADD_PRODUCT";
export const MUTATE_UPDATE_PRODUCT = "products/MUTATE_UPDATE_PRODUCT";
export const MUTATE_DELETE_PRODUCT = "products/MUTATE_DELETE_PRODUCT";
export const MUTATE_LOAD_PRODUCTPACKAGES = "products/MUTATE_LOAD_PRODUCTPACKAGES";
export const MUTATE_ADD_PRODUCTPACKAGE = "products/MUTATE_ADD_PRODUCTPACKAGE";
export const MUTATE_UPDATE_PRODUCTPACKAGE = "products/MUTATE_UPDATE_PRODUCTPACKAGE";
export const MUTATE_DELETE_PRODUCTPACKAGE = "products/MUTATE_DELETE_PRODUCTPACKAGE";

// Actions
export const ACTION_GET_PRODUCTS = "products/ACTION_GET_PRODUCTS";
export const ACTION_GET_PRODUCT = "products/ACTION_GET_PRODUCT";
export const ACTION_ADD_PRODUCT = "products/ACTION_ADD_PRODUCT";
export const ACTION_UPDATE_PRODUCT = "products/ACTION_UPDATE_PRODUCT";
export const ACTION_DELETE_PRODUCT = "products/ACTION_DELETE_PRODUCT";
export const ACTION_GET_PRODUCTPACKAGES = "products/ACTION_GET_PRODUCTPACKAGES";
export const ACTION_GET_PRODUCTPACKAGE = "products/ACTION_GET_PRODUCTPACKAGE";
export const ACTION_ADD_PRODUCTPACKAGE = "products/ACTION_ADD_PRODUCTPACKAGE";
export const ACTION_UPDATE_PRODUCTPACKAGE = "products/ACTION_UPDATE_PRODUCTPACKAGE";
export const ACTION_DELETE_PRODUCTPACKAGE = "products/ACTION_DELETE_PRODUCTPACKAGE";